function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["disable", "orient", "scale", "labelExpr", "title", "zindex"],
  _excluded2 = ["condition"],
  _excluded3 = ["test"],
  _excluded4 = ["test"];
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { array, isArray } from 'vega-util';
import { AXIS_PARTS, AXIS_PROPERTY_TYPE, CONDITIONAL_AXIS_PROP_INDEX, isConditionalAxisValue } from '../../axis';
import { POSITION_SCALE_CHANNELS } from '../../channel';
import { defaultTitle } from '../../channeldef';
import { isText } from '../../title';
import { contains, getFirstDefined, isEmpty, replaceAll } from '../../util';
import { isSignalRef } from '../../vega.schema';
import { exprFromValueRefOrSignalRef } from '../common';
import { expression } from '../predicate';
function assembleTitle(title, config) {
  if (!title) {
    return undefined;
  }
  if (isArray(title) && !isText(title)) {
    return title.map(function (fieldDef) {
      return defaultTitle(fieldDef, config);
    }).join(', ');
  }
  return title;
}
function setAxisEncode(axis, part, vgProp, vgRef) {
  var _axis$encode, _a$part, _b$update;
  var _a, _b;
  (_axis$encode = axis.encode) !== null && _axis$encode !== void 0 ? _axis$encode : axis.encode = {};
  (_a$part = (_a = axis.encode)[part]) !== null && _a$part !== void 0 ? _a$part : _a[part] = {};
  (_b$update = (_b = axis.encode[part]).update) !== null && _b$update !== void 0 ? _b$update : _b.update = {};
  // TODO: remove as any after https://github.com/prisma/nexus-prisma/issues/291
  axis.encode[part].update[vgProp] = vgRef;
}
export function assembleAxis(axisCmpt, kind, config) {
  var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    header: false
  };
  var _axisCmpt$combine = axisCmpt.combine(),
    disable = _axisCmpt$combine.disable,
    orient = _axisCmpt$combine.orient,
    scale = _axisCmpt$combine.scale,
    labelExpr = _axisCmpt$combine.labelExpr,
    title = _axisCmpt$combine.title,
    zindex = _axisCmpt$combine.zindex,
    axis = _objectWithoutProperties(_axisCmpt$combine, _excluded);
  if (disable) {
    return undefined;
  }
  for (var p in axis) {
    var prop = p;
    var propType = AXIS_PROPERTY_TYPE[prop];
    var propValue = axis[prop];
    if (propType && propType !== kind && propType !== 'both') {
      // Remove properties that are not valid for this kind of axis
      delete axis[prop];
    } else if (isConditionalAxisValue(propValue)) {
      // deal with conditional axis value
      var condition = propValue.condition,
        valueOrSignalRef = _objectWithoutProperties(propValue, _excluded2);
      var conditions = array(condition);
      var propIndex = CONDITIONAL_AXIS_PROP_INDEX[prop];
      if (propIndex) {
        var vgProp = propIndex.vgProp,
          part = propIndex.part;
        // If there is a corresponding Vega property for the channel,
        // use Vega's custom axis encoding and delete the original axis property to avoid conflicts
        var vgRef = [].concat(_toConsumableArray(conditions.map(function (c) {
          var test = c.test,
            valueOrSignalCRef = _objectWithoutProperties(c, _excluded3);
          return _objectSpread({
            test: expression(null, test)
          }, valueOrSignalCRef);
        })), [valueOrSignalRef]);
        setAxisEncode(axis, part, vgProp, vgRef);
        delete axis[prop];
      } else if (propIndex === null) {
        // If propIndex is null, this means we support conditional axis property by converting the condition to signal instead.
        var signalRef = {
          signal: conditions.map(function (c) {
            var test = c.test,
              valueOrSignalCRef = _objectWithoutProperties(c, _excluded4);
            return "".concat(expression(null, test), " ? ").concat(exprFromValueRefOrSignalRef(valueOrSignalCRef), " : ");
          }).join('') + exprFromValueRefOrSignalRef(valueOrSignalRef)
        };
        axis[prop] = signalRef;
      }
    } else if (isSignalRef(propValue)) {
      var _propIndex = CONDITIONAL_AXIS_PROP_INDEX[prop];
      if (_propIndex) {
        var _vgProp = _propIndex.vgProp,
          _part = _propIndex.part;
        // FIXME: remove as any
        setAxisEncode(axis, _part, _vgProp, propValue);
        delete axis[prop];
      } // else do nothing since the property already supports signal
    }
    // Do not pass labelAlign/Baseline = null to Vega since it won't pass the schema
    // Note that we need to use null so the default labelAlign is preserved.
    if (contains(['labelAlign', 'labelBaseline'], prop) && axis[prop] === null) {
      delete axis[prop];
    }
  }
  if (kind === 'grid') {
    if (!axis.grid) {
      return undefined;
    }
    // Remove unnecessary encode block
    if (axis.encode) {
      // Only need to keep encode block for grid
      var grid = axis.encode.grid;
      axis.encode = _objectSpread({}, grid ? {
        grid: grid
      } : {});
      if (isEmpty(axis.encode)) {
        delete axis.encode;
      }
    }
    return _objectSpread(_objectSpread({
      scale: scale,
      orient: orient
    }, axis), {}, {
      domain: false,
      labels: false,
      aria: false,
      // always hide grid axis
      // Always set min/maxExtent to 0 to ensure that `config.axis*.minExtent` and `config.axis*.maxExtent`
      // would not affect gridAxis
      maxExtent: 0,
      minExtent: 0,
      ticks: false,
      zindex: getFirstDefined(zindex, 0) // put grid behind marks by default
    });
  } else {
    // kind === 'main'
    if (!opt.header && axisCmpt.mainExtracted) {
      // if mainExtracted has been extracted to a separate facet
      return undefined;
    }
    if (labelExpr !== undefined) {
      var _axis$encode2;
      var expr = labelExpr;
      if ((_axis$encode2 = axis.encode) !== null && _axis$encode2 !== void 0 && (_axis$encode2 = _axis$encode2.labels) !== null && _axis$encode2 !== void 0 && _axis$encode2.update && isSignalRef(axis.encode.labels.update.text)) {
        expr = replaceAll(labelExpr, 'datum.label', axis.encode.labels.update.text.signal);
      }
      setAxisEncode(axis, 'labels', 'text', {
        signal: expr
      });
    }
    if (axis.labelAlign === null) {
      delete axis.labelAlign;
    }
    // Remove unnecessary encode block
    if (axis.encode) {
      var _iterator = _createForOfIteratorHelper(AXIS_PARTS),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _part2 = _step.value;
          if (!axisCmpt.hasAxisPart(_part2)) {
            delete axis.encode[_part2];
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (isEmpty(axis.encode)) {
        delete axis.encode;
      }
    }
    var titleString = assembleTitle(title, config);
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      scale: scale,
      orient: orient,
      grid: false
    }, titleString ? {
      title: titleString
    } : {}), axis), config.aria === false ? {
      aria: false
    } : {}), {}, {
      zindex: getFirstDefined(zindex, 0) // put axis line above marks by default
    });
  }
}
/**
 * Add axis signals so grid line works correctly
 * (Fix https://github.com/vega/vega-lite/issues/4226)
 */
export function assembleAxisSignals(model) {
  var axes = model.component.axes;
  var signals = [];
  var _iterator2 = _createForOfIteratorHelper(POSITION_SCALE_CHANNELS),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var channel = _step2.value;
      if (axes[channel]) {
        var _iterator3 = _createForOfIteratorHelper(axes[channel]),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var axis = _step3.value;
            if (!axis.get('disable') && !axis.get('gridScale')) {
              // If there is x-axis but no y-scale for gridScale, need to set height/width so x-axis can draw the grid with the right height. Same for y-axis and width.
              var sizeType = channel === 'x' ? 'height' : 'width';
              var update = model.getSizeSignalRef(sizeType).signal;
              if (sizeType !== update) {
                signals.push({
                  name: sizeType,
                  update: update
                });
              }
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return signals;
}
export function assembleAxes(axisComponents, config) {
  var _axisComponents$x = axisComponents.x,
    x = _axisComponents$x === void 0 ? [] : _axisComponents$x,
    _axisComponents$y = axisComponents.y,
    y = _axisComponents$y === void 0 ? [] : _axisComponents$y;
  return [].concat(_toConsumableArray(x.map(function (a) {
    return assembleAxis(a, 'grid', config);
  })), _toConsumableArray(y.map(function (a) {
    return assembleAxis(a, 'grid', config);
  })), _toConsumableArray(x.map(function (a) {
    return assembleAxis(a, 'main', config);
  })), _toConsumableArray(y.map(function (a) {
    return assembleAxis(a, 'main', config);
  }))).filter(function (a) {
    return a;
  }); // filter undefined
}